import React from 'react';
import cn from 'classnames';

import { NightsPicker } from '@lt/components';
import { useTranslation } from '@lt/localization';
import { pluralizeNights } from '../../../../../../utils/pluralizeUtils';
import SearchParamsLabel from '../SearchParamsLabel';
import SearchParamsControl from '../SearchParamsControl';

import styles from './SearchParamsNights.module.css';

interface SearchParamsNightsProps {
  nights: number;
  onChangeNights: (value: number) => void;
  isMobile?: boolean;
  isHotelOnly: boolean;
  isArchived: boolean;
}

const SearchParamsNights = ({
  isMobile,
  nights,
  onChangeNights,
  isHotelOnly,
  isArchived,
}: SearchParamsNightsProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={cn(styles.nights, { [styles.mobileNights]: isMobile })}>
        {`${nights} ${pluralizeNights(nights)}`}
      </div>
      <div className={styles.flight}>
        {t('checkout.summary.hotel.withFlight')}
      </div>
      {!isArchived && !isHotelOnly && (
        <NightsPicker
          nights={nights}
          showFlexNights={false}
          onChangeNights={onChangeNights}
          isMobile={isMobile}
          CustomControl={SearchParamsControl}
          CustomLabel={SearchParamsLabel}
        />
      )}
    </div>
  );
};

export default SearchParamsNights;
